module.exports = __webpack_public_path__ + "img/market_tech_Normal_ua.d99c77ba.webp";